// extracted by mini-css-extract-plugin
module.exports = {"header":"header-module--header--eyJbF","menu":"header-module--menu--3pvD2","about":"header-module--about--2Dcuz"};